export default "__VITE_ASSET__tufnq_MA__"